/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import tivoBrandingImg from '../../assets/images/1080p/splash-powered-by-tivo-en-405-x-81-1080-p.png';
import { RootState, useTivoSelector } from '../../core/tivo/tivo-redux-wrapper';
import { ImageLoader } from '../ImageLoader';
import { ImageLoaderTypes } from '../ImageLoader/ImageLoaderTypes';
import { NoNetworkOverlay } from '../NoNetworkOverlay';

import './SplashScreen.scss';

const SplashScreen: FunctionComponent = (): JSX.Element => {
    const partnerBrandingImageUrl = useTivoSelector(
        (state: RootState) => state.appl.partnerBrandingImageUrl,
    );

    const [isPartnerBrandingImageLoaded, setIsPartnerBrandingImageLoaded] = React.useState(false);

    return (
        <React.Fragment>
            <NoNetworkOverlay />
            <div className="splash-screen-container">
                <div className="partner-branding">
                    <ImageLoader
                        src={partnerBrandingImageUrl}
                        imageType={ImageLoaderTypes.SPLASH_SCREEN_PARTNER_BRANDING}
                        handleOnImageLoaded={(isImageLoaded: boolean) => {
                            if (isImageLoaded) {
                                setIsPartnerBrandingImageLoaded(true);
                            }
                        }}
                    />
                </div>
                {isPartnerBrandingImageLoaded && (
                    <img className="tivo-branding" src={tivoBrandingImg} />
                )}
            </div>
        </React.Fragment>
    );
};

export default SplashScreen;
